import { BiChartTableView } from '@euler/app/components/message/widgets/bi-visualization/BiChartTableView';
import { BiTableView } from '@euler/app/components/message/widgets/bi-visualization/BiTableView';
import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiVizType } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiSurfaceCard } from '../components/ui/BiSurfaceCard';
import { BiCardShown } from './functions/biCardShown';

/**
 * The rows behind the card, under it: a chart's result table as the chart
 * draws it, a KPI's columns. A table card is its own table already.
 */
export const CardTableSection = memo(({ shown }: { shown: BiCardShown }) => {
  const { rpx } = useResponsiveContext();
  const { viz, data } = shown;
  if (data.kind !== 'ready' || viz.type === BiVizType.Table) return null;
  const result = data.result.current;
  if (!result.rows.length) return null;
  return (
    <BiSurfaceCard style={{ padding: rpx(16), gap: rpx(8) }}>
      <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
        数据表
      </Typography.Text>
      {viz.type === BiVizType.Kpi ? (
        <BiTableView
          viz={{
            type: BiVizType.Table,
            columns: result.columns.map(column => ({ key: column.key })),
            ...(viz.format ? { formats: { [viz.value]: viz.format } } : {}),
            ...(viz.style?.table ? { style: { table: viz.style.table } } : {}),
          }}
          result={result}
        />
      ) : (
        <BiChartTableView viz={viz} result={result} />
      )}
    </BiSurfaceCard>
  );
});
